/* Wolpic · Editor de fotos (cuadros y álbumes) · Ecom Project
   Un mismo modelo de ajustes para la pantalla, la vista previa del pedido y el archivo de impresión:
     fx, fy  punto de la foto (0–1) que queda en el centro del espacio   z  zoom (1 = la foto cubre el espacio justo)
     r       giro en pasos de 90°        a  enderezar (−45° a 45°)        fh / fv  espejo horizontal / vertical
     f       filtro (ver FILTERS)        b, c, s  brillo, contraste y saturación (100 = sin cambio)
   La foto siempre cubre todo el espacio: nunca quedan bordes vacíos, aunque se gire o se enderece.
   WPEdit.open() abre el editor a pantalla completa; WPEdit.apply()/applyAll() dibujan el ajuste en un <img data-wpx>;
   WPEdit.draw() lo dibuja en un canvas (vista previa del pedido) y WPEdit.renderPrint() arma el archivo para imprimir. */
(function () {
  'use strict';
  if (window.WPEdit) return;

  var DEF = { fx: 0.5, fy: 0.5, z: 1, r: 0, a: 0, fh: 0, fv: 0, f: '', b: 100, c: 100, s: 100 };
  var FILTERS = [
    { id: '', name: 'Original', css: '' },
    { id: 'bn', name: 'Blanco y negro', css: 'grayscale(1)' },
    { id: 'bnc', name: 'B/N intenso', css: 'grayscale(1) contrast(1.25)' },
    { id: 'sepia', name: 'Sepia', css: 'sepia(0.85)' },
    { id: 'vivo', name: 'Vívido', css: 'saturate(1.35) contrast(1.08)' },
    { id: 'calido', name: 'Cálido', css: 'sepia(0.28) saturate(1.25) brightness(1.03)' },
    { id: 'suave', name: 'Suave', css: 'contrast(0.88) brightness(1.06) saturate(0.85)' },
    { id: 'retro', name: 'Retro', css: 'sepia(0.45) contrast(0.9) saturate(0.8) brightness(1.05)' }
  ];
  var FMAP = {}; FILTERS.forEach(function (f) { FMAP[f.id] = f; });
  var MAXZ = 5;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function n(v, d) { v = Number(v); return isFinite(v) ? v : d; }
  /* cualquier ajuste guardado (también los del formato anterior {x, y, z}) se vuelve un ajuste válido */
  function norm(e) {
    e = e || {};
    var o = {};
    if (e.fx == null && e.x != null) {   // formato anterior: foco en % (object-position) y zoom
      o.fx = clamp(n(e.x, 50) / 100, 0, 1); o.fy = clamp(n(e.y, 50) / 100, 0, 1);
    } else { o.fx = clamp(n(e.fx, 0.5), 0, 1); o.fy = clamp(n(e.fy, 0.5), 0, 1); }
    o.z = clamp(n(e.z, 1), 1, MAXZ);
    var r = Math.round(n(e.r, 0) / 90) * 90 % 360; o.r = r < 0 ? r + 360 : r;
    o.a = clamp(n(e.a, 0), -45, 45);
    o.fh = e.fh ? 1 : 0; o.fv = e.fv ? 1 : 0;
    o.f = FMAP[e.f] ? e.f : '';
    o.b = clamp(n(e.b, 100), 50, 150); o.c = clamp(n(e.c, 100), 50, 150); o.s = clamp(n(e.s, 100), 0, 200);
    if (e.u) o.u = e.u;
    return o;
  }
  function isSet(e) {
    if (!e) return false; e = norm(e);
    return Math.abs(e.fx - 0.5) > 0.004 || Math.abs(e.fy - 0.5) > 0.004 || e.z > 1.01 || e.r || Math.abs(e.a) > 0.05 || e.fh || e.fv || e.f || e.b !== 100 || e.c !== 100 || e.s !== 100;
  }
  function hasTone(e) { return !!(e.f || e.b !== 100 || e.c !== 100 || e.s !== 100); }
  function filterCss(e) {
    e = norm(e);
    var p = [];
    if (e.f) p.push(FMAP[e.f].css);
    if (e.b !== 100) p.push('brightness(' + e.b / 100 + ')');
    if (e.c !== 100) p.push('contrast(' + e.c / 100 + ')');
    if (e.s !== 100) p.push('saturate(' + e.s / 100 + ')');
    return p.join(' ');
  }
  function fmt(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }
  /* texto para el pedido y para el taller */
  function describe(e) {
    if (!isSet(e)) return '';
    e = norm(e);
    var p = [];
    if (e.z > 1.01) p.push('zoom ×' + fmt(e.z));
    if (Math.abs(e.fx - 0.5) > 0.004 || Math.abs(e.fy - 0.5) > 0.004) p.push('centro en ' + Math.round(e.fx * 100) + ' % horizontal / ' + Math.round(e.fy * 100) + ' % vertical');
    if (e.r) p.push('girada ' + e.r + '°');
    if (Math.abs(e.a) > 0.05) p.push('enderezada ' + fmt(e.a) + '°');
    if (e.fh) p.push('espejo');
    if (e.fv) p.push('volteada');
    if (e.f) p.push('filtro ' + FMAP[e.f].name.toLowerCase());
    if (e.b !== 100) p.push('brillo ' + (e.b > 100 ? '+' : '') + (e.b - 100) + ' %');
    if (e.c !== 100) p.push('contraste ' + (e.c > 100 ? '+' : '') + (e.c - 100) + ' %');
    if (e.s !== 100) p.push('saturación ' + (e.s > 100 ? '+' : '') + (e.s - 100) + ' %');
    return p.join(', ');
  }

  /* ---------- geometría: la misma para la pantalla, la vista previa y la impresión ---------- */
  function geo(e, W, H, iw, ih) {
    var T = (e.r + e.a) * Math.PI / 180, cs = Math.abs(Math.cos(T)), sn = Math.abs(Math.sin(T));
    var ex = W / 2 * cs + H / 2 * sn, ey = W / 2 * sn + H / 2 * cs;    // medio ancho y medio alto del espacio, en los ejes de la foto
    var S = Math.max(2 * ex / iw, 2 * ey / ih) * e.z;
    var hx = ex / (iw * S), hy = ey / (ih * S);
    return { T: T, S: S, fx: hx >= 0.5 ? 0.5 : clamp(e.fx, hx, 1 - hx), fy: hy >= 0.5 ? 0.5 : clamp(e.fy, hy, 1 - hy) };
  }
  /* corrige el punto central para que la foto siga cubriendo el espacio (al hacer zoom, girar o cambiar el margen) */
  function fit(e, W, H, iw, ih) { e = norm(e); var g = geo(e, W, H, iw, ih); e.fx = g.fx; e.fy = g.fy; return e; }
  /* mover la foto con el dedo: dx, dy en píxeles de pantalla */
  function panBy(e, dx, dy, W, H, iw, ih) {
    e = norm(e);
    var g = geo(e, W, H, iw, ih), c = Math.cos(g.T), s = Math.sin(g.T);
    var lx = dx * c + dy * s, ly = -dx * s + dy * c;
    if (e.fh) lx = -lx; if (e.fv) ly = -ly;
    e.fx = g.fx - lx / (g.S * iw); e.fy = g.fy - ly / (g.S * ih);
    return fit(e, W, H, iw, ih);
  }
  function transformCss(e, W, H, iw, ih) {
    var g = geo(e, W, H, iw, ih);
    return 'translate(' + (W / 2) + 'px,' + (H / 2) + 'px) rotate(' + g.T + 'rad) scale(' + (e.fh ? -g.S : g.S) + ',' + (e.fv ? -g.S : g.S) + ') translate(' + (-g.fx * iw) + 'px,' + (-g.fy * ih) + 'px)';
  }

  /* ---------- en la página: <img data-wpx='{…}'> dentro de un contenedor con overflow oculto ---------- */
  function readEdit(img) { try { return norm(JSON.parse(img.getAttribute('data-wpx') || '{}')); } catch (err) { return norm({}); } }
  function apply(img, e) {
    if (!img) return;
    if (e) img.setAttribute('data-wpx', JSON.stringify(norm(e)));
    var box = img.parentNode; if (!box) return;
    if (!img.complete || !img.naturalWidth) {
      if (!img.__wpxWait) { img.__wpxWait = 1; img.addEventListener('load', function () { img.__wpxWait = 0; apply(img); }, { once: true }); }
      img.style.opacity = '0';
      return;
    }
    var W = box.clientWidth, H = box.clientHeight, iw = img.naturalWidth, ih = img.naturalHeight;
    if (!W || !H) return;
    var ed = readEdit(img), st = img.style;
    st.position = 'absolute'; st.left = '0'; st.top = '0'; st.margin = '0'; st.maxWidth = 'none'; st.maxHeight = 'none'; st.minWidth = '0'; st.minHeight = '0';
    st.width = iw + 'px'; st.height = ih + 'px'; st.objectFit = 'fill'; st.objectPosition = '50% 50%';
    st.transformOrigin = '0 0'; st.transform = transformCss(ed, W, H, iw, ih);
    st.filter = filterCss(ed) || '';
    st.opacity = '';
  }
  function applyAll(root) {
    var list = (root || document).querySelectorAll('img[data-wpx]');
    for (var i = 0; i < list.length; i++) apply(list[i]);
  }
  function attr(e) { return String(JSON.stringify(norm(e))).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  /* etiqueta <img> lista para insertar con innerHTML */
  function imgHtml(src, e, cls, lazy) {
    return '<img class="wpx-img' + (cls ? ' ' + cls : '') + '" src="' + String(src).replace(/"/g, '&quot;') + '" alt="" draggable="false"' + (lazy ? ' loading="lazy"' : '') + ' data-wpx="' + attr(e) + '" style="opacity:0">';
  }

  /* ---------- canvas: vista previa del pedido y archivo de impresión ---------- */
  var M = {
    grayscale: function (a) { var t = 1 - a; return [0.2126 + 0.7874 * t, 0.7152 - 0.7152 * t, 0.0722 - 0.0722 * t, 0.2126 - 0.2126 * t, 0.7152 + 0.2848 * t, 0.0722 - 0.0722 * t, 0.2126 - 0.2126 * t, 0.7152 - 0.7152 * t, 0.0722 + 0.9278 * t]; },
    sepia: function (a) { var t = 1 - a; return [0.393 + 0.607 * t, 0.769 - 0.769 * t, 0.189 - 0.189 * t, 0.349 - 0.349 * t, 0.686 + 0.314 * t, 0.168 - 0.168 * t, 0.272 - 0.272 * t, 0.534 - 0.534 * t, 0.131 + 0.869 * t]; },
    saturate: function (s) { return [0.213 + 0.787 * s, 0.715 - 0.715 * s, 0.072 - 0.072 * s, 0.213 - 0.213 * s, 0.715 + 0.285 * s, 0.072 - 0.072 * s, 0.213 - 0.213 * s, 0.715 - 0.715 * s, 0.072 + 0.928 * s]; }
  };
  /* convierte la cadena de filtros CSS en una sola transformación de color (matriz 3×3 + desplazamiento) */
  function toneMatrix(css) {
    var A = [1, 0, 0, 0, 1, 0, 0, 0, 1], o = [0, 0, 0], re = /(\w+)\(([\d.]+)\)/g, m;
    function mul(B, ob) {
      var R = [], no = [];
      for (var i = 0; i < 3; i++) {
        for (var j = 0; j < 3; j++) R[i * 3 + j] = B[i * 3] * A[j] + B[i * 3 + 1] * A[3 + j] + B[i * 3 + 2] * A[6 + j];
        no[i] = B[i * 3] * o[0] + B[i * 3 + 1] * o[1] + B[i * 3 + 2] * o[2] + ob[i];
      }
      A = R; o = no;
    }
    while ((m = re.exec(css))) {
      var k = m[1], v = parseFloat(m[2]);
      if (M[k]) mul(M[k](v), [0, 0, 0]);
      else if (k === 'brightness') mul([v, 0, 0, 0, v, 0, 0, 0, v], [0, 0, 0]);
      else if (k === 'contrast') mul([v, 0, 0, 0, v, 0, 0, 0, v], [0.5 - 0.5 * v, 0.5 - 0.5 * v, 0.5 - 0.5 * v]);
    }
    return { A: A, o: [o[0] * 255, o[1] * 255, o[2] * 255] };
  }
  function tone(ctx, x, y, w, h, css) {
    if (!css) return;
    var x0 = Math.max(0, Math.floor(x)), y0 = Math.max(0, Math.floor(y));
    w = Math.min(ctx.canvas.width, Math.ceil(x + w)) - x0; h = Math.min(ctx.canvas.height, Math.ceil(y + h)) - y0;
    if (w < 1 || h < 1) return;
    var T = toneMatrix(css), A = T.A, o = T.o;
    try {
      var d = ctx.getImageData(x0, y0, w, h), p = d.data;
      for (var i = 0; i < p.length; i += 4) {
        var r = p[i], g = p[i + 1], b = p[i + 2];
        p[i] = A[0] * r + A[1] * g + A[2] * b + o[0];
        p[i + 1] = A[3] * r + A[4] * g + A[5] * b + o[1];
        p[i + 2] = A[6] * r + A[7] * g + A[8] * b + o[2];
      }
      ctx.putImageData(d, x0, y0);
    } catch (err) {}
  }
  function draw(ctx, img, x, y, w, h, e) {
    if (!img || !img.naturalWidth || w < 1 || h < 1) return;
    e = norm(e);
    var iw = img.naturalWidth, ih = img.naturalHeight, g = geo(e, w, h, iw, ih);
    ctx.save();
    ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
    ctx.translate(x + w / 2, y + h / 2); ctx.rotate(g.T); ctx.scale(e.fh ? -g.S : g.S, e.fv ? -g.S : g.S);
    ctx.imageSmoothingEnabled = true; try { ctx.imageSmoothingQuality = 'high'; } catch (err) {}
    ctx.drawImage(img, -g.fx * iw, -g.fy * ih, iw, ih);
    ctx.restore();
    if (hasTone(e)) tone(ctx, x, y, w, h, filterCss(e));
  }

  /* ---------- Uploadcare: tamaño real de la foto y archivo para imprimir ---------- */
  function ucBase(u) {
    var m = String(u || '').match(/^(https?:\/\/[^/]*(?:ucarecdn|ucarecd\.net)[^/]*\/[0-9a-f-]{36}\/)(.*)$/i);
    if (!m) return null;
    var mods = (m[2] || '').replace(/-\/(preview|resize|scale_crop|quality|format|progressive|stretch|json)\/[^/]*\/?/g, '').replace(/^\/+/, '');
    if (mods && mods.slice(-1) !== '/') mods += '/';
    mods = mods.replace(/[^/]*\.[a-z0-9]{2,5}$/i, '');   // nombre del archivo al final del enlace
    return m[1] + mods;
  }
  var infoCache = {};
  function info(url) {
    var b = ucBase(url);
    if (!b || !window.fetch) return Promise.resolve(null);
    if (!infoCache[b]) infoCache[b] = fetch(b + '-/json/').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j && j.width ? { w: j.width, h: j.height } : null; }).catch(function () { return null; });
    return infoCache[b];
  }
  /* la foto en alta (hasta 4000 px por lado, en JPG aunque el original sea HEIC) */
  function hiresUrl(url) { var b = ucBase(url); return b ? b + '-/preview/4000x4000/-/format/jpeg/-/quality/best/' : url; }
  /* calidad de impresión: píxeles reales de la foto que quedan dentro del espacio, por pulgada impresa */
  function quality(e, aspect, src, cm) {
    if (!src || !cm || !cm.w) return null;
    e = norm(e);
    var W = 1000 * aspect, H = 1000, g = geo(e, W, H, src.w, src.h);
    var dpi = (W / g.S) / (cm.w / 2.54);
    return { dpi: Math.round(dpi), level: dpi >= 200 ? 'excelente' : dpi >= 140 ? 'buena' : dpi >= 95 ? 'aceptable' : 'baja' };
  }
  /* arma el archivo para imprimir con los ajustes del cliente */
  function renderPrint(url, e, aspect, maxLong) {
    var C = window.WPCapture; if (!C) return Promise.resolve(null);
    maxLong = maxLong || 3600;
    return C.load(hiresUrl(url), 45000).then(function (img) {
      if (!img) return null;
      e = norm(e);
      var W = 1000 * aspect, H = 1000, g = geo(e, W, H, img.naturalWidth, img.naturalHeight);
      var vw = W / g.S, vh = H / g.S, k = Math.min(1, maxLong / Math.max(vw, vh));   // no se agranda más que la foto original
      var ow = Math.max(1, Math.round(vw * k)), oh = Math.max(1, Math.round(vh * k));
      var cv = document.createElement('canvas'); cv.width = ow; cv.height = oh;
      var ctx = cv.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, ow, oh);
      draw(ctx, img, 0, 0, ow, oh, e);
      return cv;
    }).catch(function () { return null; });
  }
  function uploadPrint(url, e, aspect, name) {
    var C = window.WPCapture; if (!C) return Promise.resolve(null);
    return renderPrint(url, e, aspect).then(function (cv) {
      if (!cv) return null;
      var p = C.upload(cv, name || 'foto-lista-para-imprimir.jpg', 0.93);
      cv.width = cv.height = 1;   // libera memoria en celulares
      return p;
    });
  }
  /* corre tareas de a pocas a la vez, con un tiempo máximo total; avisa el avance */
  function pool(tasks, limit, ms, onStep) {
    var out = new Array(tasks.length), i = 0, active = 0, done = 0, over = false;
    return new Promise(function (resolve) {
      if (!tasks.length) return resolve(out);
      var t = setTimeout(function () { over = true; resolve(out); }, ms || 90000);
      function next() {
        if (over) return;
        if (done === tasks.length) { clearTimeout(t); return resolve(out); }
        while (active < limit && i < tasks.length) {
          (function (k) {
            active++;
            Promise.resolve().then(tasks[k]).catch(function () { return null; }).then(function (v) {
              out[k] = v; active--; done++; if (onStep && !over) onStep(done, tasks.length); next();
            });
          })(i++);
        }
      }
      next();
    });
  }

  /* =====================================================================
     EDITOR A PANTALLA COMPLETA
     ===================================================================== */
  var CSS =
    '.wpx-img{pointer-events:none;user-select:none;-webkit-user-select:none;will-change:transform;transition:opacity .15s}' +
    '.wpfp-photo,.wpae-slot,.wpae-cover__win,.wpae-cover__full{overflow:hidden}' +
    '.wpfp-num,.wpfp-plus,.wpae-num,.wpae-plus{z-index:2}' +
    '.wpx-chip{position:absolute;right:5px;bottom:5px;z-index:3;display:inline-flex;align-items:center;gap:4px;height:26px;padding:0 9px;border:0;border-radius:999px;background:rgba(22,34,74,.88);color:#fff;font:600 11.5px/1 system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;cursor:pointer;box-shadow:0 2px 6px rgba(0,0,0,.25)}' +
    '.wpx-chip svg{width:13px;height:13px}.wpx-chip.is-icon{width:26px;padding:0;justify-content:center}' +
    '.wpx-chip:focus-visible{outline:2px solid #3fd3c1;outline-offset:2px}' +
    '.wpx-lowres{position:absolute;left:5px;bottom:5px;z-index:3;padding:3px 7px;border-radius:999px;background:#b4462e;color:#fff;font:700 10.5px/1.2 system-ui,sans-serif;pointer-events:none}' +
    '.wpx{position:fixed;inset:0;z-index:2147483600;display:flex;flex-direction:column;background:#0f1424;color:#fff;font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;opacity:0;transition:opacity .18s}' +
    '.wpx.is-open{opacity:1}.wpx *{box-sizing:border-box}' +
    '.wpx-top{display:flex;align-items:center;gap:10px;padding:10px 14px;padding-top:max(10px,env(safe-area-inset-top))}' +
    '.wpx-top__t{flex:1;min-width:0;text-align:center}.wpx-top__t strong{display:block;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.wpx-top__t small{display:block;font-size:12px;color:#aab1c7;margin-top:2px}' +
    '.wpx-btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;min-height:40px;padding:0 16px;border-radius:999px;border:1px solid rgba(255,255,255,.22);background:transparent;color:#fff;font:600 14px/1 inherit;cursor:pointer;white-space:nowrap}' +
    '.wpx-btn:hover{background:rgba(255,255,255,.08)}.wpx-btn:focus-visible{outline:2px solid #3fd3c1;outline-offset:2px}' +
    '.wpx-btn--primary{background:#3a6be0;border-color:#3a6be0}.wpx-btn--primary:hover{background:#2a55c4}' +
    '.wpx-stage{position:relative;flex:1 1 auto;min-height:0;display:flex;align-items:center;justify-content:center;padding:18px;overflow:hidden;touch-action:none}' +
    '.wpx-box{position:relative;overflow:hidden;background:#232a40;box-shadow:0 0 0 9999px rgba(15,20,36,.62),0 10px 40px rgba(0,0,0,.5);cursor:grab;touch-action:none}' +
    '.wpx-box.is-drag{cursor:grabbing}.wpx-box .wpx-img{opacity:1}' +
    '.wpx-ghostimg{position:absolute;pointer-events:none;opacity:.28;transform-origin:0 0}' +
    '.wpx-grid{position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .2s;background-image:linear-gradient(rgba(255,255,255,.55),rgba(255,255,255,.55)),linear-gradient(rgba(255,255,255,.55),rgba(255,255,255,.55)),linear-gradient(90deg,rgba(255,255,255,.55),rgba(255,255,255,.55)),linear-gradient(90deg,rgba(255,255,255,.55),rgba(255,255,255,.55));background-size:100% 1px,100% 1px,1px 100%,1px 100%;background-position:0 33.33%,0 66.66%,33.33% 0,66.66% 0;background-repeat:no-repeat;box-shadow:inset 0 0 0 2px rgba(255,255,255,.85)}' +
    '.wpx-box.is-drag .wpx-grid,.wpx.is-straight .wpx-grid{opacity:1}' +
    '.wpx-grid.is-fine{background-image:repeating-linear-gradient(rgba(255,255,255,.28) 0 1px,transparent 1px 10%),repeating-linear-gradient(90deg,rgba(255,255,255,.28) 0 1px,transparent 1px 10%);background-size:auto;background-position:0 0}' +
    '.wpx-q{position:absolute;left:50%;top:10px;transform:translateX(-50%);z-index:2;padding:5px 11px;border-radius:999px;font-size:12px;font-weight:600;background:rgba(15,20,36,.78);white-space:nowrap}' +
    '.wpx-q i{display:inline-block;width:8px;height:8px;border-radius:50%;margin-right:6px;vertical-align:0}' +
    '.wpx-q.is-excelente i,.wpx-q.is-buena i{background:#3fd3c1}.wpx-q.is-aceptable i{background:#f1b84b}.wpx-q.is-baja{background:#b4462e}.wpx-q.is-baja i{background:#fff}' +
    '.wpx-hint{text-align:center;font-size:12px;color:#aab1c7;margin:0 0 8px;padding:0 12px}' +
    '.wpx-panel{background:#161c30;border-top:1px solid rgba(255,255,255,.08);padding:10px 14px;padding-bottom:max(12px,env(safe-area-inset-bottom))}' +
    '.wpx-tabs{display:flex;justify-content:center;gap:6px;margin-bottom:10px}' +
    '.wpx-tab{min-height:36px;padding:0 14px;border-radius:999px;border:0;background:transparent;color:#aab1c7;font:600 13.5px/1 inherit;cursor:pointer}' +
    '.wpx-tab.is-active{background:#fff;color:#16224a}' +
    '.wpx-pane{max-width:640px;margin:0 auto}' +
    '.wpx-row{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin:8px 0}' +
    '.wpx-tool{display:inline-flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;min-width:64px;min-height:56px;padding:6px 8px;border-radius:12px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.04);color:#fff;font:600 11.5px/1.1 inherit;cursor:pointer}' +
    '.wpx-tool svg{width:20px;height:20px}.wpx-tool:hover{background:rgba(255,255,255,.1)}.wpx-tool.is-on{border-color:#3fd3c1;color:#3fd3c1}' +
    '.wpx-tool:focus-visible,.wpx-tab:focus-visible,.wpx-filter:focus-visible{outline:2px solid #3fd3c1;outline-offset:2px}' +
    '.wpx-slider{display:grid;grid-template-columns:96px 1fr 52px;align-items:center;gap:10px;margin:8px 0;font-size:13px}' +
    '.wpx-slider label{color:#d6dbe8}.wpx-slider output{text-align:right;font-variant-numeric:tabular-nums;color:#aab1c7}' +
    '.wpx-slider input{width:100%;accent-color:#3fd3c1;height:28px}' +
    '.wpx-filters{display:flex;gap:10px;overflow-x:auto;padding:4px 2px 8px;scrollbar-width:thin}' +
    '.wpx-filter{flex:none;width:76px;border:0;background:none;color:#d6dbe8;font:600 11.5px/1.2 inherit;cursor:pointer;padding:0}' +
    '.wpx-filter span{position:relative;display:block;width:76px;height:76px;border-radius:10px;overflow:hidden;margin-bottom:5px;border:2px solid transparent;background:#232a40}' +
    '.wpx-filter span img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;max-width:none}' +
    '.wpx-filter.is-active span{border-color:#3fd3c1}.wpx-filter.is-active{color:#fff}' +
    '.wpx-reset{display:block;margin:6px auto 0;border:0;background:none;color:#aab1c7;font:600 12.5px inherit;text-decoration:underline;cursor:pointer}' +
    '.wpx-loading{position:absolute;inset:0;display:grid;place-items:center;font-size:13px;color:#aab1c7}' +
    '@media (min-width:900px){.wpx-panel{padding-left:24px;padding-right:24px}.wpx-stage{padding:28px}}' +
    '@media (max-height:640px){.wpx-tool{min-height:46px;min-width:56px}.wpx-slider{margin:4px 0}}';
  function injectCss() {
    if (document.getElementById('wpx-css')) return;
    var s = document.createElement('style'); s.id = 'wpx-css'; s.textContent = CSS; document.head.appendChild(s);
  }
  var ICON = {
    left: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4v6h6"/><path d="M3.5 10A9 9 0 1 1 6 18.5"/></svg>',
    right: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 4v6h-6"/><path d="M20.5 10A9 9 0 1 0 18 18.5"/></svg>',
    mirror: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v18"/><path d="M8 7L3 12l5 5z"/><path d="M16 7l5 5-5 5z"/></svg>',
    flip: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12h18"/><path d="M7 8l5-5 5 5z"/><path d="M7 16l5 5 5-5z"/></svg>',
    center: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="3"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/></svg>',
    fill: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M8 9l-2 3 2 3M16 9l2 3-2 3"/></svg>',
    edit: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/></svg>'
  };

  var cur = null;   // editor abierto
  function isOpen() { return !!cur; }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function q(s, r) { return (r || document).querySelector(s); }

  /* opts: { src, aspect, edit, title, subtitle, cm:{w,h}, base:'grayscale(1)' (efecto de la variante), onDone(edit), onCancel() } */
  function open(opts) {
    injectCss();
    if (cur) close(false);
    var e = norm(opts.edit), start = JSON.stringify(e), aspect = opts.aspect > 0 ? opts.aspect : 1;
    var root = el('div', 'wpx');
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Editar foto');
    root.innerHTML =
      '<header class="wpx-top">' +
        '<button type="button" class="wpx-btn" data-x="cancel">Cancelar</button>' +
        '<div class="wpx-top__t"><strong></strong><small></small></div>' +
        '<button type="button" class="wpx-btn wpx-btn--primary" data-x="done">Aplicar</button>' +
      '</header>' +
      '<div class="wpx-stage"><div class="wpx-box"><div class="wpx-loading">Cargando tu foto…</div><div class="wpx-grid"></div></div><div class="wpx-q" hidden></div></div>' +
      '<p class="wpx-hint">' + (window.matchMedia && matchMedia('(hover: none)').matches ? 'Arrastra la foto para moverla · pellizca para hacer zoom' : 'Arrastra la foto para moverla · usa la rueda del mouse o el zoom') + '</p>' +
      '<div class="wpx-panel">' +
        '<div class="wpx-tabs" role="tablist"><button type="button" class="wpx-tab" data-tab="crop">Recortar y girar</button><button type="button" class="wpx-tab" data-tab="filters">Filtros</button><button type="button" class="wpx-tab" data-tab="tone">Luz y color</button></div>' +
        '<div class="wpx-pane"></div>' +
      '</div>';
    q('.wpx-top__t strong', root).textContent = opts.title || 'Editar foto';
    q('.wpx-top__t small', root).textContent = opts.subtitle || 'Así quedará impresa';
    var stage = q('.wpx-stage', root), box = q('.wpx-box', root), grid = q('.wpx-grid', root), qBadge = q('.wpx-q', root), pane = q('.wpx-pane', root);
    var img = new Image(); img.className = 'wpx-img'; img.alt = ''; img.draggable = false;
    var srcInfo = null, tab = 'crop', W = 0, H = 0;
    document.body.appendChild(root);
    var prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    var lastFocus = document.activeElement;

    function layout() {
      var sw = stage.clientWidth - 36, sh = stage.clientHeight - 36;
      if (sw < 40 || sh < 40) return;
      W = Math.min(sw, sh * aspect); H = W / aspect;
      box.style.width = Math.round(W) + 'px'; box.style.height = Math.round(H) + 'px';
      W = Math.round(W); H = Math.round(H);
      render();
    }
    function render() {
      if (!img.naturalWidth || !W) return;
      e = fit(e, W, H, img.naturalWidth, img.naturalHeight);
      img.setAttribute('data-wpx', JSON.stringify(e));
      img.style.cssText = 'position:absolute;left:0;top:0;margin:0;max-width:none;max-height:none;opacity:1;transform-origin:0 0;width:' + img.naturalWidth + 'px;height:' + img.naturalHeight + 'px;transform:' + transformCss(e, W, H, img.naturalWidth, img.naturalHeight) + ';filter:' + ([opts.base || '', filterCss(e)].join(' ').trim() || 'none');
      var ql = quality(e, aspect, srcInfo, opts.cm);
      if (ql) {
        qBadge.hidden = false; qBadge.className = 'wpx-q is-' + ql.level;
        qBadge.innerHTML = '<i></i>' + (ql.level === 'baja' ? 'Calidad baja: se verá pixelada. Usa menos zoom u otra foto' : 'Calidad de impresión: ' + ql.level + (ql.level === 'aceptable' ? ' (evita más zoom)' : ''));
      } else qBadge.hidden = true;
      syncControls();
    }
    function syncControls() {
      var map = { z: e.z, a: e.a, b: e.b, c: e.c, s: e.s };
      Object.keys(map).forEach(function (k) {
        var inp = q('input[data-k="' + k + '"]', pane); if (!inp) return;
        if (document.activeElement !== inp) inp.value = map[k];
        var out = q('output[data-k="' + k + '"]', pane);
        if (out) out.textContent = k === 'z' ? '×' + fmt(map[k]) : k === 'a' ? fmt(map[k]) + '°' : (map[k] - 100 > 0 ? '+' : '') + (map[k] - 100);
      });
      var mi = q('[data-act="mirror"]', pane); if (mi) mi.classList.toggle('is-on', !!e.fh);
      var fl = q('[data-act="flip"]', pane); if (fl) fl.classList.toggle('is-on', !!e.fv);
      Array.prototype.forEach.call(pane.querySelectorAll('.wpx-filter'), function (b) { var on = b.getAttribute('data-f') === e.f; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
    }
    function slider(k, label, min, max, step) {
      return '<div class="wpx-slider"><label for="wpx-' + k + '">' + label + '</label><input id="wpx-' + k + '" type="range" data-k="' + k + '" min="' + min + '" max="' + max + '" step="' + step + '"><output data-k="' + k + '"></output></div>';
    }
    function tool(act, icon, label) { return '<button type="button" class="wpx-tool" data-act="' + act + '">' + ICON[icon] + '<span>' + label + '</span></button>'; }
    function renderPane() {
      Array.prototype.forEach.call(root.querySelectorAll('.wpx-tab'), function (b) { var on = b.getAttribute('data-tab') === tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
      if (tab === 'crop') {
        pane.innerHTML =
          slider('z', 'Zoom', 1, MAXZ, 0.01) + slider('a', 'Enderezar', -45, 45, 0.5) +
          '<div class="wpx-row">' + tool('left', 'left', 'Girar ⟲') + tool('right', 'right', 'Girar ⟳') + tool('mirror', 'mirror', 'Espejo') + tool('flip', 'flip', 'Voltear') + tool('center', 'center', 'Centrar') + tool('fill', 'fill', 'Ajustar al espacio') + '</div>' +
          '<button type="button" class="wpx-reset" data-act="reset">Restablecer todo</button>';
      } else if (tab === 'filters') {
        var src = img.currentSrc || img.src;
        pane.innerHTML = '<div class="wpx-filters">' + FILTERS.map(function (f) {
          return '<button type="button" class="wpx-filter" data-f="' + f.id + '"><span><img src="' + src.replace(/"/g, '&quot;') + '" alt="" style="filter:' + ([opts.base || '', f.css].join(' ').trim() || 'none') + '"></span>' + f.name + '</button>';
        }).join('') + '</div>';
      } else {
        pane.innerHTML = slider('b', 'Brillo', 50, 150, 1) + slider('c', 'Contraste', 50, 150, 1) + slider('s', 'Saturación', 0, 200, 1) +
          '<button type="button" class="wpx-reset" data-act="tone-reset">Restablecer luz y color</button>';
      }
      syncControls();
    }
    function set(patch) { for (var k in patch) e[k] = patch[k]; e = norm(e); render(); }

    pane.addEventListener('input', function (ev) {
      var k = ev.target.getAttribute && ev.target.getAttribute('data-k'); if (!k) return;
      var p = {}; p[k] = parseFloat(ev.target.value); set(p);
      if (k === 'a') root.classList.add('is-straight');
    });
    pane.addEventListener('change', function (ev) { if (ev.target.getAttribute && ev.target.getAttribute('data-k') === 'a') root.classList.remove('is-straight'); });
    pane.addEventListener('pointerup', function () { root.classList.remove('is-straight'); });
    pane.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-act], [data-f]'); if (!b) return;
      if (b.hasAttribute('data-f')) { set({ f: b.getAttribute('data-f') }); return; }
      var a = b.getAttribute('data-act');
      if (a === 'left') set({ r: e.r - 90 });
      else if (a === 'right') set({ r: e.r + 90 });
      else if (a === 'mirror') set({ fh: e.fh ? 0 : 1 });
      else if (a === 'flip') set({ fv: e.fv ? 0 : 1 });
      else if (a === 'center') set({ fx: 0.5, fy: 0.5 });
      else if (a === 'fill') set({ z: 1, fx: 0.5, fy: 0.5, a: 0 });
      else if (a === 'reset') { e = norm({}); render(); }
      else if (a === 'tone-reset') set({ f: '', b: 100, c: 100, s: 100 });
    });
    root.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-tab]'); if (t) { tab = t.getAttribute('data-tab'); renderPane(); return; }
      var x = ev.target.closest('[data-x]'); if (!x) return;
      if (x.getAttribute('data-x') === 'done') finish(true); else finish(false);
    });

    /* arrastrar para mover, pellizcar para zoom */
    var ptrs = {}, last = null, pinch = null;
    function pts() { return Object.keys(ptrs).map(function (k) { return ptrs[k]; }); }
    box.addEventListener('pointerdown', function (ev) {
      if (!img.naturalWidth) return;
      ev.preventDefault();
      try { box.setPointerCapture(ev.pointerId); } catch (err) {}
      ptrs[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
      var p = pts();
      if (p.length === 2) { pinch = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1, z: e.z }; last = null; }
      else { last = { x: ev.clientX, y: ev.clientY }; pinch = null; }
      box.classList.add('is-drag');
    });
    box.addEventListener('pointermove', function (ev) {
      if (!ptrs[ev.pointerId]) return;
      ptrs[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
      var p = pts();
      if (pinch && p.length >= 2) {
        var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1;
        set({ z: pinch.z * d / pinch.d });
      } else if (last) {
        e = panBy(e, ev.clientX - last.x, ev.clientY - last.y, W, H, img.naturalWidth, img.naturalHeight);
        last = { x: ev.clientX, y: ev.clientY };
        render();
      }
    });
    function up(ev) {
      delete ptrs[ev.pointerId];
      var p = pts();
      if (p.length === 1) { last = { x: p[0].x, y: p[0].y }; pinch = null; }
      if (!p.length) { last = null; pinch = null; box.classList.remove('is-drag'); }
    }
    box.addEventListener('pointerup', up); box.addEventListener('pointercancel', up);
    box.addEventListener('wheel', function (ev) { ev.preventDefault(); set({ z: e.z * (ev.deltaY < 0 ? 1.08 : 1 / 1.08) }); }, { passive: false });
    box.addEventListener('dblclick', function () { set({ z: e.z > 1.05 ? 1 : 2 }); });
    function onKey(ev) {
      if (!cur || cur.root !== root) return;
      var tag = (ev.target.tagName || '').toLowerCase();
      if (ev.key === 'Escape') { ev.preventDefault(); ev.stopPropagation(); finish(false); return; }
      if (tag === 'input') { if (/^Arrow/.test(ev.key)) ev.stopPropagation(); return; }
      if (/^Arrow|^[+=-]$/.test(ev.key)) ev.stopPropagation();   // las flechas no cambian de página detrás del editor
      var step = ev.shiftKey ? 20 : 4;
      if (ev.key === 'ArrowLeft') { ev.preventDefault(); e = panBy(e, step, 0, W, H, img.naturalWidth, img.naturalHeight); render(); }
      else if (ev.key === 'ArrowRight') { ev.preventDefault(); e = panBy(e, -step, 0, W, H, img.naturalWidth, img.naturalHeight); render(); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); e = panBy(e, 0, step, W, H, img.naturalWidth, img.naturalHeight); render(); }
      else if (ev.key === 'ArrowDown') { ev.preventDefault(); e = panBy(e, 0, -step, W, H, img.naturalWidth, img.naturalHeight); render(); }
      else if (ev.key === '+' || ev.key === '=') set({ z: e.z * 1.1 });
      else if (ev.key === '-') set({ z: e.z / 1.1 });
      else if (ev.key === 'Tab') {   // el foco no sale del editor
        var list = Array.prototype.filter.call(root.querySelectorAll('button, input'), function (x) { return x.offsetParent !== null; });
        if (!list.length) return;
        if (ev.shiftKey && document.activeElement === list[0]) { ev.preventDefault(); list[list.length - 1].focus(); }
        else if (!ev.shiftKey && document.activeElement === list[list.length - 1]) { ev.preventDefault(); list[0].focus(); }
      }
    }
    document.addEventListener('keydown', onKey, true);
    var rt; function onResize() { clearTimeout(rt); rt = setTimeout(layout, 60); }
    window.addEventListener('resize', onResize);

    function finish(ok) {
      if (!cur || cur.root !== root) return;
      var res = norm(e);
      close();
      if (ok) { if (opts.onDone) opts.onDone(res, JSON.stringify(res) !== start); }
      else if (opts.onCancel) opts.onCancel();
    }
    cur = {
      root: root,
      cancel: function () { finish(false); },
      cleanup: function () {
        document.removeEventListener('keydown', onKey, true);
        window.removeEventListener('resize', onResize);
        document.documentElement.style.overflow = prevOverflow;
        root.classList.remove('is-open');
        setTimeout(function () { if (root.parentNode) root.parentNode.removeChild(root); }, 180);
        if (lastFocus && lastFocus.focus && document.contains(lastFocus)) try { lastFocus.focus({ preventScroll: true }); } catch (err) {}
      }
    };

    img.onload = function () { var l = q('.wpx-loading', box); if (l) l.remove(); layout(); if (tab === 'filters') renderPane(); };
    img.onerror = function () { var l = q('.wpx-loading', box); if (l) l.textContent = 'No pudimos cargar la foto. Revisa tu conexión.'; };
    box.insertBefore(img, grid);
    img.src = opts.src;
    if (opts.info) Promise.resolve(opts.info).then(function (i) { srcInfo = i; render(); });
    renderPane();
    requestAnimationFrame(function () { root.classList.add('is-open'); layout(); try { q('[data-x="done"]', root).focus({ preventScroll: true }); } catch (err) {} });
    return cur;
  }
  function close() { if (!cur) return; var c = cur; cur = null; c.cleanup(); }
  function cancel() { if (cur) cur.cancel(); }

  window.WPEdit = {
    FILTERS: FILTERS, DEF: DEF, norm: norm, isSet: isSet, describe: describe, filterCss: filterCss,
    geo: geo, fit: fit, panBy: panBy, apply: apply, applyAll: applyAll, imgHtml: imgHtml, draw: draw, tone: tone,
    info: info, hiresUrl: hiresUrl, quality: quality, renderPrint: renderPrint, uploadPrint: uploadPrint, pool: pool,
    open: open, close: close, cancel: cancel, isOpen: isOpen, injectCss: injectCss, ICON: ICON
  };
  injectCss();
})();
